import React from "react";
import { getFingerprintInstallerDownloads } from "../../utils/mantraFingerprint";

/**
 * Installer links shown only when the scanner reports as not connected.
 */
const FingerprintInstallerDownloads = ({ visible }) => {
  const downloads = getFingerprintInstallerDownloads();
  if (!visible || !downloads.length) return null;

  return (
    <div className="mt-3 rounded-lg border border-amber-200 bg-amber-50 px-3 py-3 text-left">
      <p className="text-sm font-UbuntuMedium text-amber-900 m-0 mb-2">
        Scanner not connected. Download and install both files on this PC, plug
        in the device, then check again.
      </p>
      <div className="flex flex-col gap-1.5">
        {downloads.map((item) => (
          <a
            key={item.url}
            href={item.url}
            className="text-sm font-UbuntuMedium text-primary underline hover:opacity-80"
          >
            {item.label}
          </a>
        ))}
      </div>
    </div>
  );
};

export default FingerprintInstallerDownloads;
